// extracted by mini-css-extract-plugin
export default {"socialButton":"social-button_socialButton__LlU8b","quickSign":"social-button_quickSign__woOpR"};